<template>
  <div id="loading-bg">
    <div class="loading-logo">
      <img src="@/assets/images/logo/logo.png" alt="Logo">
    </div>
    <div class="loading">
      <div class="effect-1 effects"></div>
      <div class="effect-2 effects"></div>
      <div class="effect-3 effects"></div>
    </div>
  </div>
</template>
<script>
  import EventEmitter from 'events';
  // 'loggedIn' is used in other parts of application. So, Don't forget to change there also

  class AuthService extends EventEmitter {
    profile = null;
    tokenExpiry = null;
    }

  // export default new AuthService();
  export default {
    methods: {
      handleLoginEvent(data) {
        this.$store.dispatch('auth/updateAuthenticatedUser', {
          displayName: data.profile.name,
          email: data.profile.email,
          photoURL: data.profile.picture,
          providerId: data.profile.sub.substr(0, data.profile.sub.indexOf('|')),
          uid: data.profile.sub
        })
        this.$router.push(data.state.target || "/");
      }
    },
    created() {
      try {
        this.$auth.signinRedirectCallback().then(result => {
          var loginSuccess = this.$auth.login(result);
          if (loginSuccess) {
            var returnToUrl = '/';
            if (result.state !== undefined) { returnToUrl = result.state; }
            this.$router.push({ path: returnToUrl });
          } else {
            this.$router.push({ path: '/unauthorized' });
          }
        });
      } catch (e) {
        this.$router.push({ path: '/unauthorized' });
      }
    }
  };
</script>
<style lang="scss">

  @import "../assets/css/loader.css"
</style>
